(() => {
  const CONTRACT = 'fangster-r14-ux-20260712';
  const RETURN_KEY = 'fangster:return-context:v1';
  const MAX_CONTEXT_AGE = 12 * 60 * 60 * 1000;
  const routes = window.FANGSTER_ROUTES || {};
  const strings = (window.FANGSTER_I18N && window.FANGSTER_I18N.strings) || {};
  const rootPath = new URL(routes.root || '/', window.location.origin).pathname.replace(/\/$/, '');
  const storefrontPath = (pathname) => rootPath && pathname.startsWith(`${rootPath}/`)
    ? pathname.slice(rootPath.length)
    : pathname;
  const listingPath = (pathname) => {
    const path = storefrontPath(pathname);
    return path === '/search' || path.startsWith('/collections/');
  };

  document.documentElement.dataset.fangsterUxContract = CONTRACT;

  const readContext = () => {
    try {
      const value = JSON.parse(sessionStorage.getItem(RETURN_KEY) || 'null');
      if (!value || !value.url || Date.now() - Number(value.savedAt || 0) > MAX_CONTEXT_AGE) return null;
      const url = new URL(value.url, window.location.origin);
      if (url.origin !== window.location.origin || !listingPath(url.pathname)) return null;
      return value;
    } catch (_) {
      return null;
    }
  };

  const writeContext = (value) => {
    try {
      sessionStorage.setItem(RETURN_KEY, JSON.stringify(value));
    } catch (_) {
      /* Browsing still works when storage is unavailable. */
    }
  };

  const listingTitle = () => {
    const heading = document.querySelector(
      '.fg-collection-hero h1, .collection-hero__title, .template-search__header h1, main h1'
    );
    return heading ? heading.textContent.trim() : (strings.results || 'results');
  };

  const captureListingContext = (event) => {
    if (!listingPath(window.location.pathname)) return;
    const link = event.target.closest('a[href*="/products/"]');
    if (!link) return;

    writeContext({
      url: window.location.href,
      title: listingTitle(),
      scrollY: Math.max(0, Math.round(window.scrollY)),
      savedAt: Date.now(),
      restoreScroll: false
    });
  };

  document.addEventListener('pointerdown', captureListingContext, true);
  document.addEventListener('click', captureListingContext, true);

  const restoreListingScroll = () => {
    if (!listingPath(window.location.pathname)) return;
    const context = readContext();
    if (!context || !context.restoreScroll || context.url !== window.location.href) return;

    const targetY = Number(context.scrollY || 0);
    context.restoreScroll = false;
    context.savedAt = Date.now();
    writeContext(context);

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => window.scrollTo({ top: targetY, behavior: 'auto' }));
    });
  };

  const enhanceProductReturn = () => {
    if (!storefrontPath(window.location.pathname).startsWith('/products/')) return;
    const nav = document.querySelector('[data-fg-return-nav]');
    const link = nav && nav.querySelector('[data-fg-return-link]');
    if (!link) return;

    let context = readContext();
    if (!context && document.referrer) {
      try {
        const referrer = new URL(document.referrer);
        if (referrer.origin === window.location.origin && listingPath(referrer.pathname)) {
          context = {
            url: referrer.href,
            title: strings.results || 'results',
            scrollY: 0,
            savedAt: Date.now(),
            restoreScroll: false
          };
          writeContext(context);
        }
      } catch (_) {
        context = null;
      }
    }

    if (!context) return;
    link.href = context.url;
    const labelTemplate = strings.backTo || 'Back to __LABEL__';
    link.querySelector('[data-fg-return-label]').textContent = labelTemplate.replace('__LABEL__', context.title || strings.results || 'results');
    link.addEventListener('click', () => {
      context.restoreScroll = true;
      context.savedAt = Date.now();
      writeContext(context);
    });
  };

  const verifyFilterContract = () => {
    if (!listingPath(window.location.pathname)) return;
    window.setTimeout(() => {
      const desktopForm = document.getElementById('FacetFiltersForm');
      const mobileForm = document.getElementById('FacetFiltersFormMobile');
      const hasNativeForm = Boolean(desktopForm || mobileForm);
      const status = hasNativeForm ? 'native-v1' : 'missing-native-form';

      document.documentElement.dataset.fangsterFilterStatus = status;
      if (!hasNativeForm) {
        console.warn(`[${CONTRACT}] Native filter form verification failed.`);
      }
    }, 350);
  };

  const init = () => {
    restoreListingScroll();
    enhanceProductReturn();
    verifyFilterContract();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

